import { DefaultColumnOptions } from "../../../../../hooks/useDataGrid/options";

export const Columns = [
  DefaultColumnOptions.Id,
  {
    headerName: "Tier Name",
    field: "name",
    sortable: true,
    sort: "asc",
    tooltipField: "name",
  },
  {
    headerName: "Title Associated",
    field: "titleAssociated",
    sortable: true,
    tooltipField: "titleAssociated",
  },
];
